<template>
    <v-form ref="socilaMediaForm">
        <social-media-fields :initialValue="formData" @update="syncFormData" @validityChanged="syncFormValidity"></social-media-fields>

        <!--Only show cancel if text is set. Always show submit, but only enable it if the form is valid-->
        <v-btn v-if="cancelButtonText" @click="raiseCancel" flat color="error">{{cancelButtonText}}</v-btn>
        <v-btn @click="submit" :disabled="disableContinue">{{submitButtonText}}</v-btn>
    </v-form>
</template>

<script>
  import {FormMixin, BasicFormSyncMixin} from '@/forms/mixins'
  import SocialMediaFields from '@/forms/company/SocialMediaFields'

  export default {
    name: 'SocialMediaForm',
    mixins: [FormMixin, BasicFormSyncMixin],
    components: {SocialMediaFields},
    data: () => ({
      // Because the form is optional, we have to set the default values here as well, so that the parent updates
      // correctly
      formData: {
        website: null,
        twitter: null,
        facebook: null,
      },
    }),
    computed: {
      disableContinue () {
        // By default formValid is null, which evaluates to false
        return this.formValid === false
      }
    },
    methods: {
      submit () {
        if (!this.disableContinue) {
          // Parent should use this to handle form submission, shockingly
          this.$emit('submitted', this.formData)
        }
      }
    }
  }
</script>

<style scoped>

</style>
